import React, { useEffect } from "react";
import { Table, Switch, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { usePromptModel } from "../promptModel";
import { ISCMBeDetails, ISCMPromptDetail } from "../promptService";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys,
    } = usePromptModel();

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<ISCMPromptDetail> = [
        {
            title: '序号',
            width: 60,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '分支编码',
            width: 120,
            dataIndex: 'branch',
            fixed: "left",
        }, {
            title: '系统名称',
            width: 160,
            dataIndex: 'systemName',
            fixed: "left",
        },{
            title: '功能模块',
            width: 160,
            dataIndex: 'moduleName',
        }, {
            title: '提示信息',
            width: 220,
            dataIndex: 'promptInformation',
        }, {
            title: '父级编码',
            width: 100,
            dataIndex: 'pcode',
        }, {
            title: '错误编码',
            width: 120,
            dataIndex: 'errorCode',
        }, 
    ];


    //点击行选高亮
    const onRow = (id: string) => {
        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === id) {
            setSelectedRowKeys([]);
        } else {
            setSelectedRowKeys([id]);
        }
    };

    return (
        <Table
            rowKey={record => record.id}
            rowSelection={{
                type: "radio",
                selectedRowKeys: selectedRowKeys, //记录选中
                onChange: (selectedRowKeys: React.Key[], selectedRows: ISCMPromptDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                }
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id)
            })}
            scroll={{ x: 'max-content' }}
        />
    )
}
